'use client';

import { useTranslation } from 'react-i18next';
import { useRouter } from 'next/navigation';
import { useEffect, useState } from 'react';

import { Icon } from '@iconify/react';

export function LanguageSwitcher() {
    const { i18n } = useTranslation();
    const router = useRouter();
    const [mounted, setMounted] = useState(false);

    useEffect(() => {
        setMounted(true);
        // Sync the initial loaded language with the server cookie if missing/different
        const currentLang = i18n.language || 'es';
        document.cookie = `NEXT_LOCALE=${currentLang}; path=/; max-age=31536000; SameSite=Lax`;
    }, [i18n.language]);

    const toggleLanguage = () => {
        const nextLocale = i18n.language === 'en' ? 'es' : 'en';
        i18n.changeLanguage(nextLocale);

        // Set a cookie so the server knows the language
        document.cookie = `NEXT_LOCALE=${nextLocale}; path=/; max-age=31536000; SameSite=Lax`;

        // Refresh the router to re-fetch Server Components with the new locale
        router.refresh();
    };

    if (!mounted) return <div className="w-8 h-8" />;

    const currentLanguage = i18n.language || 'es';

    return (
        <button
            onClick={toggleLanguage}
            className="h-9 px-3 flex items-center gap-1.5 rounded-full text-slate-700 hover:text-slate-900 dark:text-slate-200 dark:hover:text-white hover:bg-slate-100 dark:hover:bg-white/10 transition-all duration-300 font-bold text-[10px] hover:scale-105 active:scale-95"
            aria-label={`${currentLanguage.toUpperCase()} — switch to ${currentLanguage === 'en' ? 'Spanish' : 'English'}`}
        >
            <Icon icon="solar:global-linear" className="w-4 h-4" />
            <span>{currentLanguage.toUpperCase()}</span>
        </button>
    );
}
